import { QueryClient } from '@tanstack/query-core';

// Gets all the search stops queries from the query cache
export const getUseSearchStopsQueryKeys = (queryClient: QueryClient) => {
  const queryCache = queryClient.getQueryCache();
  const plannerSearchStopsQueries = queryCache
    .getAll()
    .filter((cache) => typeof cache.queryKey[0] === `string` && cache.queryKey[0].startsWith(`planner_search_stops`))
    .sort((a, b) => b.state.dataUpdatedAt - a.state.dataUpdatedAt);

  return plannerSearchStopsQueries;
};
